import { Navigate, useParams, useSearchParams } from 'react-router-dom'

import { CogTileLayerProxy } from '@/components/map/cog-tile-layer/proxy'
import { useGetCogUrlFromDiagnosis } from '@/hooks/queries/use-get-cog-url-from-diagnosis'

import View from '../../components/view'
import { useGetInfestationComparisonByFieldFromRegion } from '../../hooks/queries/use-get-infestation-comparison-by-field-from-region'
import { useCompanies } from '../../hooks/use-companies'
import { routes } from '../../routes/config'
import { SwapButton } from './components/swap-button'
import {
  CompareDiagnosesProvider,
  useCompareDiagnoses,
} from './contexts/compare-diagnoses-context'
import { InfestationMap } from './insfestation-map'
import { SelectDiagnosisToAnalysis } from './insfestation-map/components/select-diagnosis-to-analysis'
import { ViewDiagnosisButton } from './insfestation-map/components/view-diagnosis-button'
import LateralPanelCompare from './lateral-panel-compare'
import { useStyles } from './styles'

function DiagnosesCompareComponent() {
  const classes = useStyles()
  const { selectedCompany } = useCompanies()

  const {
    regionId,
    fieldIds,
    baseDiagnosisId,
    compareDiagnosisId,
    allDiagnosesAvailable,
    allDiagnosesAvailableForCompare,
    setBaseDiagnosisId,
    setCompareDiagnosisId,
  } = useCompareDiagnoses()

  const { data } = useGetInfestationComparisonByFieldFromRegion(
    regionId,
    fieldIds,
    baseDiagnosisId,
    compareDiagnosisId,
  )

  const { data: cogUrlBaseDiagnosis } = useGetCogUrlFromDiagnosis(
    'cane',
    baseDiagnosisId,
  )
  const { data: cogUrlCompareDiagnosis } = useGetCogUrlFromDiagnosis(
    'cane',
    compareDiagnosisId,
  )

  return (
    <div className={classes.root}>
      <View
        variant='compare'
        padding='XS'
        aside={<LateralPanelCompare />}
        leftNode={
          <div className={classes.leftNode}>
            <InfestationMap
              infestation={data?.base_diagnosis.geojson}
              layerColors={data?.layer_colors || {}}
            >
              <SelectDiagnosisToAnalysis
                value={baseDiagnosisId}
                options={allDiagnosesAvailable || []}
                onSelectChange={setBaseDiagnosisId}
                title='Diagnóstico 01'
                disabled={!allDiagnosesAvailable}
              />
              <ViewDiagnosisButton
                href={routes.DiagnosisView(
                  selectedCompany.id.toString(),
                  'cane',
                  'weed',
                  baseDiagnosisId,
                )}
              />
              {cogUrlBaseDiagnosis && (
                <CogTileLayerProxy url={cogUrlBaseDiagnosis} />
              )}
            </InfestationMap>
            <SwapButton />
          </div>
        }
        rightNode={
          <InfestationMap
            infestation={data?.comparison_diagnosis.geojson}
            layerColors={data?.layer_colors || {}}
          >
            <SelectDiagnosisToAnalysis
              value={compareDiagnosisId}
              options={allDiagnosesAvailableForCompare || []}
              onSelectChange={setCompareDiagnosisId}
              title='Diagnóstico 02'
              disabled={!baseDiagnosisId}
            />
            <ViewDiagnosisButton
              href={routes.DiagnosisView(
                selectedCompany.id.toString(),
                'cane',
                'weed',
                compareDiagnosisId,
              )}
            />
            {cogUrlCompareDiagnosis && (
              <CogTileLayerProxy url={cogUrlCompareDiagnosis} />
            )}
          </InfestationMap>
        }
      />
    </div>
  )
}

export default function DiagnosesCompare() {
  const { projectId, regionId } = useParams<{
    projectId: string
    regionId: string
  }>()

  const [searchParams] = useSearchParams()

  const fieldIds = searchParams.getAll('fields')

  if (!projectId || !regionId || !fieldIds.length) {
    return <Navigate to={routes.Maps()} />
  }

  return (
    <CompareDiagnosesProvider
      projectId={parseInt(projectId, 10)}
      regionId={parseInt(regionId, 10)}
      fieldIds={fieldIds}
    >
      <DiagnosesCompareComponent />
    </CompareDiagnosesProvider>
  )
}
